import React from 'react';
import Chart from 'react-apexcharts';

const options = {
    chart: {
        type: 'line',
        toolbar: {
            show: false,
        },
        zoom: {
            enabled: false,
        },
        grid: {
            show: false,
        },
        colors: ['#9A3B3D'],
        grid: {
            show: false,
        },
    },
    grid: {
        show: true, // Keep grid lines visible
        borderColor: 'transparent', // Set color to transparent
    },
    xaxis: {
        labels: {
            show: false,
        },
    },
    yaxis: {
        labels: {
            show: false,
        },
    },
};

const series = [
    {
        name: 'Series 1',
        data: [30, 40, 45, 50, 49, 60, 70],
        color: '#9A3B3D',
    },
];

const CardChart = () => {
    return (
        <div className="chart-container" style={{ padding: "0px", margin: "0px" }}>
            <Chart options={options} series={series} type="line" width={200} height={100} />
        </div>
    );
};

export default CardChart;
